// extracted by mini-css-extract-plugin
module.exports = {"enrollBtn":"ClosingHero_enrollBtn__gd7_m","icon":"ClosingHero_icon___Jr0x","right_col":"ClosingHero_right_col__2E35N"};